import intl from 'react-intl-universal';
import { useSelector } from 'react-redux';
import Skelton from '../../../../../Atoms/Skelton/Skelton';
import { getProjectLineItemStatus } from '../../../../../state/BudgetList/budgetListSlice';
import { SLICE_STATUS } from '../../../../../utils/constants';
import { Option } from '../../../../../utils/customTypes';
import ReportCard from '../../../../BudgetsPage/components/ReportCard';

const BudgetSummaryView = ({
  totalAmount,
  totalActual,
  activeTimeframe,
}: {
  totalAmount: number;
  totalActual: number;
  activeTimeframe?: Option;
}) => {
  const lineItemStatus = useSelector(getProjectLineItemStatus);

  return (
    <div className='mb-8'>
      {lineItemStatus === SLICE_STATUS.LOADING && (
        <div className='grid grid-cols-3 gap-4 mt-6'>
          {Array.from({ length: 3 }).map((num, index) => (
            <Skelton key={index} className='w-full h-20 rounded' />
          ))}
        </div>
      )}
      {lineItemStatus === SLICE_STATUS.IDLE && (
        <div className='grid grid-cols-3 gap-4 mt-6'>
          <ReportCard
            dataTestId='total-budget'
            title={
              intl.get('BUDGET_PAGE.REPORT.TIMEFRAME.TOTAL_BUDGET') +
              ' (' +
              activeTimeframe?.label +
              ')'
            }
            value={totalAmount}
          />
          <ReportCard
            dataTestId='total-actual'
            title={
              intl.get('BUDGET_PAGE.REPORT.TIMEFRAME.ACTUALS') +
              ' (' +
              activeTimeframe?.label +
              ')'
            }
            value={totalActual}
          />
          <ReportCard
            dataTestId='variance'
            title={
              intl.get('BUDGET_PAGE.REPORT.TIMEFRAME.VARIANCE') +
              ' (' +
              activeTimeframe?.label +
              ')'
            }
            value={totalAmount - totalActual}
          />
        </div>
      )}
    </div>
  );
};

export default BudgetSummaryView;
